export const environment = {
  production: true,
  API_URL_V1:
    'https://iqcentralproduction-eqerhre6fzcxgvfu.centralus-01.azurewebsites.net',
  filterConfig: {
    apiUrl:
      'https://iqcentralproduction-eqerhre6fzcxgvfu.centralus-01.azurewebsites.net',
  },
  FRONTEND_ENTERPRISE_URL: 'https://org.iqcentral.quomodosystems.ng',
  FRONTEND_LEARNERS_URL: 'https://learner.iqcentral.quomodosystems.ng',
  FRONTEND_CONTENT_PROVIDERS_URL: 'https://cp.iqcentral.quomodosystems.ng',
  FRONTEND_HOMEPAGE_URL: 'https://iqcentral.quomodosystems.ng',
};
